export enum Mode {
  WALK = 'WALK',
  CYCLE = 'CYCLE',
  CAR = 'SELF_DRIVE_CAR',
  PUBLIC_TRANSPORT = 'PUBLIC_TRANSPORT',
  BIKE_AND_RIDE = 'BIKE_AND_RIDE',
  PARK_AND_RIDE = 'PARK_AND_RIDE',
}
